/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-legacy';
const componentName = 'tech-support-data-transformer';
const prefix = `${moduleName}.${componentName}`;

export const completeSuccessfullyLabel = `${prefix}.completeSuccessfullyLabel`;
export const completeErrorLabel = `${prefix}.completeErrorLabel`;

export const ENGLISH = {
    [completeSuccessfullyLabel]: 'Completed successfully',
    [completeErrorLabel]: 'Completed with errors',
};
